<template>
  <div class="userinfo-add">
    <userinfoTeacher v-show="step == 1" @getSchoolInfo="getSchoolInfo" />
    <userinfoSchool
      v-if="step == 2 && classShow"
      @previous="previous"
      @submit="submit"
      :roleList="roleList"
      :classSelectList="classSelectList"
      :schoolName="schoolName"
    />
  </div>
</template>

<script>
import userinfoTeacher from "./components/userinfo-teacher/userinfo-teacher.vue";
import userinfoSchool from "./components/userinfo-school/userinfo-school.vue";

export default {
  name: "userinfo",
  components: {
    userinfoTeacher,
    userinfoSchool,
  },
  data() {
    return {
      step: 1,
      classShow: false,
      teacherInfo: {},
      phone: "",
      classSelectList: [],
      roleList: [
        {
          isCharge: 1,
          roleName: "班主任",
        },
        {
          isCharge: 0,
          roleName: "科任老师",
        },
      ],
      schoolName: "",
    };
  },
  created() {
    // this.phone = this.$route.query.phone;
    // console.log(this.phone);
  },
  methods: {
    // 子组件userinfoTeacher 点击下一步时传递的事件
    // 获取学校信息
    getSchoolInfo(res) {
      this.classSelectList = [];
      // console.log(res);
      // res.teacherInfo：子组件 userinfoTeacher 填写的教师信息
      this.teacherInfo = res.teacherInfo;
      // console.log(this.teacherInfo)
      let { teacherNumber, teacherName, entryDate, resume } = this.teacherInfo;
      // res.inviteCode：邀请码
      // 教师登陆根据邀请码绑定学校并修改个人信息
      this.post(this.$url.updateTeacherLoginInformationPC, {
        inviteCode: res.inviteCode,
        id: this.user.id,
        teacherNumber,
        teacherName,
        entryDate,
        resume,
      })
        .then((res) => {
          // console.log(res);
          // 绑定学校成功
          if (res.code == 200) {
            // 获取用户最新消息更新vuex
            this.updateUserInfo();
          } else {
            return this.$message.error("修改失败");
          }
        })
        .catch((err) => {
          return this.$message.error("修改失败，请稍后再试");
        });
    },

    // 获取用户最新消息并更新vuex
    updateUserInfo() {
      this.$store
        .dispatch("user/getInfo")
        .then((res) => {
          // console.log(res);
          // console.log(this.user);
          // console.log(schoolId)
          // this.schoolName = res.schoolName;
          // let schoolId = res.schoolId;
          this.$router
            .push({
              // path: this.redirect || "/",
              path: "/",
              query: "home-page",
            })
            .catch(() => {});
          // 获取班级和科目列表 传给子组件 userinfoSchool
          // 获取年级和班级选择列表
          // this.selectSchoolAndGradeAndClassListPC(schoolId);
          // 显示userinfoSchool
          // this.step = 2;
        })
        .catch((err) => {
          console.log(err);
          return this.$message.error("修改失败，请稍后重试");
        });
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC(schoolId) {
      this.post(this.$url.selectSchoolAndGradeAndClassListPC, {
        schoolId,
      })
        .then((res) => {
          // console.log(res);
          this.classSelectList = res.rows;
          this.classShow = true;
        })
        .catch((err) => {
          return this.$message.error("获取学校信息失败，请稍后重试");
        });
    },
    // 查看教师权限（身份）
    // getRolelist() {
    //   this.get(this.$url.getRolelist)
    //     .then((res) => {
    //       // console.log(res);
    //       this.roleList = res.data;
    //     })
    //     .catch((err) => {
    //       return this.$message.error("获取学校信息失败，请稍后重试");
    //     });
    // },
    previous() {
      this.step = 1;
    },
    // 提交
    submit(options) {
      // console.log(options);
      // options.submitList：子组件 userinfoSchool 选中的数据
      // 调用接口，成功绑定班级后更新vuex的classList
      this.post(this.$url.classteacherAdd, options.submitList)
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$store
              .dispatch("classInfo/getClassInfo", { id: this.user.id })
              .then(() => {
                this.$message.success("提交成功");
                this.$router.push("/");
              });
          } else if (res.code == 500) {
            this.$message.error(
              "绑定失败，选择的班级中存在重复绑定班主任的班级"
            );
          } else {
            this.$message.error("提交失败");
          }
        })
        .catch((err) => {
          this.$message.error("提交失败，请稍后重试");
        });
    },
  },
};
</script>

<style lang="scss" scoped >
@import "./userinfo-add.scss";
</style>